import {computed, inject, Injectable, signal} from '@angular/core';
import {LocalStorageService} from './storage.service';
import {ApiAppService, ZERODATE} from '@kilobytelab/domain';
import {Informe} from '@kilobytelab/types';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class InformesService {

  private appService = inject(AppService);
  private localstorage = inject(LocalStorageService);
  private apiApp = inject(ApiAppService);

  INFORMES = signal<Informe[]>([]);

  informesDisponibles = computed<boolean>(() =>
    this.INFORMES().some(i => i.fechaVisto === ZERODATE)
  )

  async checkInformes() {
    const appInfo = this.appService.APP();
    const alumnos = this.appService.PADRE();
    if (!appInfo?.informes || !alumnos?.length) {
      this.INFORMES.set([]);
      await this.localstorage.setInformes([]);
      return
    }
    try {
      const informes: Informe[] = await this.apiApp.getInformes();
      await this.updateInformes(informes)
    } catch (err) {
      const guardados: Informe[] = await this.localstorage.getInformes();
      if (!guardados) {
        throw new Error('Error recuperando los informes')
      }
      this.INFORMES.set(guardados)
    }
  }

  private async updateInformes(informes: Informe[]) {
    const actuales = this.INFORMES();
    if (!actuales.length) {
      this.INFORMES.set(informes);
      await this.localstorage.setInformes(informes);
      return
    }
    const diccionarioActuales = new Map(
      actuales.map(i => [`${i.idAlumno}-${i.curso}-${i.trimestre}`, i])
    );
    const fusionados: Informe[] = informes.map(nuevo => {
      const clave = `${nuevo.idAlumno}-${nuevo.curso}-${nuevo.trimestre}`;
      const existente = diccionarioActuales.get(clave);
      return existente ? { ...existente, ...nuevo } : { ...nuevo }
    });
    this.INFORMES.set(fusionados);
    await this.localstorage.setInformes(fusionados)
  }

}